import Modal from "@via/components/modal.tsx";
import { ModalSize } from "@via/utils/constants.tsx";
import { PIPELINE_GIT_EXPORT_RETIRED_MESSAGE } from "common";
import { type FC } from "react";

interface ExportPipelineModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  // Given only when this user can download the .vf file (administrators, and
  // never for an external pipeline), so the button matches the menu item.
  onDownloadVfFile?: () => void;
}

// The Git export is retired (decision git-d2, task git-3-6), and the server
// refuses it with the same message. ExportPipelineForm is kept, unrendered,
// until the whole pipeline git export (git-3-3) replaces it.
const ExportPipelineModal: FC<ExportPipelineModalProps> = ({
  open,
  setOpen,
  onDownloadVfFile,
}) => {
  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Export Pipeline"
      showButtons={false}
      size={ModalSize.Large}>
      <div className="py-4">
        <p className="text-sm text-gray-700">
          {PIPELINE_GIT_EXPORT_RETIRED_MESSAGE}
        </p>
        <div className="modal-footer flex justify-end space-x-2 mt-4">
          {onDownloadVfFile && (
            <button
              id="export-pipeline-modal-download-vf-button"
              type="button"
              onClick={() => {
                onDownloadVfFile();
                setOpen(false);
              }}
              className="inline-flex items-center gap-x-1.5 rounded-md px-3 py-2 text-sm text-white shadow-sm duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600">
              Download VF File
            </button>
          )}
          <button
            id="export-pipeline-modal-cancel-button"
            data-testid="modalCancelButton"
            type="button"
            onClick={() => setOpen(false)}
            className="inline-flex items-center gap-x-1.5 rounded-md px-3 py-2 text-sm text-white shadow-sm duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 bg-gray-600 hover:bg-gray-500 focus-visible:outline-gray-600">
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ExportPipelineModal;
